module.exports = __webpack_public_path__ + "img/1.023ac1dc.png";